import { Rate } from 'antd';
import styled from 'utils/styled';

export const Container = styled.div``;

export const InputContainer = styled.div`
  width: 50%;

  @media (max-width: 568px) {
    width: 100%;
  }
`;

export const RatingDescContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    margin-bottom: 4px;
    font-size: 12px;
    flex: 1;
    text-align: center;
  }
`;

export const StyledRate = styled(Rate)`
  line-height: 50px;
  font-size: 32px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
  padding: 0 64px;

  .ant-rate-star-zero {
    color: #fff;
  }
  .ant-rate-star-second,
  .and-rate-star-first {
    color: #fff;
  }

  @media (max-width: 568px) {
    padding: 0 16px;
  }
`;
